//@flow

export const SlotType = Object.freeze({
    EVERYDAY: 'EVERYDAY',
    CUSTOM: 'CUSTOM'
});

export type SlotTypeEnumType = $Values<typeof SlotType>;
